<template lang="pug">
  .component-policy
    .inner-content(v-if="$is('listing')")
      .row
        .column.shrink
          dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
            SegmentButtons(:item="item", @itemUpdated="$emit('itemUpdated')")

        .column
          .label SGR{{item.id}}
          .field SG{{item.segment.id}} {{item.segment.name}}
        .column
          .label Rate
          .field
            router-link(:to="{name:'configuration-rate', params:{id:item.reservation_rate.id}}")
              span RR{{item.reservation_rate.id}} {{item.reservation_rate.name}}
</template>

<script>
  import CardN from '../structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import FederationButtons from '../structure/ui/actions/FederationButtons'
  import CouponButtons from '../structure/ui/actions/CouponButtons'
  import SegmentButtons from "../structure/ui/actions/SegmentButtons";

  export default {
    name: 'SegmentRate',
    components: {SegmentButtons, CouponButtons, FederationButtons, Dropdown, CardN},
    props: ['item', 'type']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SegmentRate.vue?8f3bc916